import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const AddTaskModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add New Todo</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form.Group className="mb-3">
          <Form.Label>Todo Title</Form.Label>
          <Form.Control />
        </Form.Group>

        <Row>
          <Col>
            <Form.Label>Tag</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Col>

          <Col>
            <Form.Label>Priority</Form.Label>
            <Form.Select>
              <option>Select</option>
            </Form.Select>
          </Col>
        </Row>

        <Form.Group className="mt-3">
          <Form.Label>Description</Form.Label>
          <Form.Control as="textarea" rows={4} />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Add Assignee</Form.Label>
          <Form.Select>
            <option>Select</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Status</Form.Label>
          <Form.Select>
            <option>Select</option>
          </Form.Select>
        </Form.Group>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">
          Add New Todo
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTaskModal;